import { connectCpOrderMessages } from 'components/secondaryMarket/cpOrder/sidePanel/messages.connect';
import { Messages } from 'components/secondaryMarket/shared/SidePanel/Messages';
import { SidePanelStructure } from 'components/secondaryMarket/shared/SidePanel/SidePanelStructure';
import { FC, useState } from 'react';

import { ConnectedNotReadySidePanel } from './notReady';
import { ConnectedOrderPlacedSidePanel } from './orderPlaced';
import { PendingOrderSidePanel } from './pending';
import { ConnectedReadySidePanel } from './ready';
import { ConnectedRejectedOrderSidePanel } from './rejected';
import type { SidePanelProps } from './sidePanel.connect';
import { connectSidePanel } from './sidePanel.connect';

export const CpOrderSideMessages = connectCpOrderMessages(Messages);

export const CpOrderSidePanel: FC<SidePanelProps> = ({ tabId, status }) => {
  const [isTraderMessageHidden, setHideTraderMessage] = useState(false);
  const [isSalesMessageHidden, setHideSalesMessage] = useState(false);
  return (
    <SidePanelStructure>
      {status === 'NOT_READY' && (
        <ConnectedNotReadySidePanel tabId={tabId} className="flex-grow-1 min-h-0">
          <CpOrderSideMessages
            tabId={tabId}
            isSalesMessageHidden={isSalesMessageHidden}
            hideSalesMessage={() => setHideSalesMessage(true)}
            isTraderMessageHidden={isTraderMessageHidden}
            hideTraderMessage={() => setHideTraderMessage(true)}
          />
        </ConnectedNotReadySidePanel>
      )}
      {status === 'READY' && (
        <ConnectedReadySidePanel tabId={tabId} className="flex-grow-1 min-h-0">
          <CpOrderSideMessages
            tabId={tabId}
            isSalesMessageHidden={isSalesMessageHidden}
            hideSalesMessage={() => setHideSalesMessage(true)}
            isTraderMessageHidden={isTraderMessageHidden}
            hideTraderMessage={() => setHideTraderMessage(true)}
          />
        </ConnectedReadySidePanel>
      )}
      {status === 'ORDER_PENDING' && <PendingOrderSidePanel className="flex-grow-1 min-h-0" />}
      {status === 'ORDER_PLACED' && <ConnectedOrderPlacedSidePanel tabId={tabId} className="flex-grow-1 min-h-0" />}
      {status === 'ORDER_FAILED' && <ConnectedRejectedOrderSidePanel tabId={tabId} className="flex-grow-1 min-h-0" />}
    </SidePanelStructure>
  );
};

CpOrderSidePanel.displayName = 'CpOrderSidePanel';

export const ConnectedCpOrderSidePanel = connectSidePanel(CpOrderSidePanel);
